import CHElement from "./CHElement";
import EntityStats from "./EntityStats";
import Pilot from "./Pilot";

class Site {
  constructor(
    public id_user: number,
    public id_pilot: number,
    public id_country: number,
    public name: string,
    public description: string | undefined,
    public icon: number | undefined,
    public latitude: number | undefined,
    public longitude: number | undefined,
    public id?: number | undefined,
    public GUID?: string | undefined,
    public created_on?: string | undefined,
    public icon_path?: string | undefined,
    public counts?: EntityStats[] | undefined,
    public username?: string | undefined,
    public pilots?: Pilot[],
    public id_chelements?: number[],
    public chelements?: CHElement[],
  ) {}

  public static EmptyInstance(): Site {
    return new Site(-1, 0, -1, "", "", -1, undefined, undefined);
  }
}

export default Site;
